module.exports = __webpack_public_path__ + "img/cazanii-1742-pagina-de-titlu-big.ec855d67.jpg";